import { ThingNameSchema } from '@org-avp/device-models';
import { BrandSchema, KvpsDealerIdSchema, MarketSchema } from '@org-avp/models';
import { z } from 'zod';
export const SessionIdSchema = z.string().uuid();
export const DeviceStatusSchema = z.enum(['pending', 'pairing-failed', 'online', 'offline']);
export const DeviceSchema = z.object({
    thingName: ThingNameSchema,
    displayName: z.string(),
    sessionId: SessionIdSchema.optional(),
    /** @deprecated Use `status` field instead */
    online: z.boolean().optional(),
    lastOnlineAt: z.number().optional(),
    idleAppOwner: z.string().optional(),
    /** The URL of the idle app currently configured for this device. */
    idleAppUrl: z.url().optional(),
    serialNumber: z.string().optional(),
    /** When the device has been created. Timestamp in seconds since epoch. */
    createdAt: z.int().optional(),
});
export const DeviceManageSchema = z.object({
    thingName: ThingNameSchema,
    displayName: z.string(),
    serialNumber: z.string().optional(),
    status: DeviceStatusSchema,
    lastOnlineAt: z.number().optional(),
    brand: BrandSchema,
    market: MarketSchema,
    dealerId: KvpsDealerIdSchema,
    /** The URL of the idle app currently configured for this device. */
    idleAppUrl: z.string().url().optional(),
});
export const IdleConfigUpdateSchema = z.object({
    url: z.string().url(),
    config: z.string(),
});
export const SessionCreateSchema = z.object({
    url: z.string().url(),
    config: z.string().optional(),
});
export const SessionUpdateSchema = z.object({
    config: z.string(),
});
//# sourceMappingURL=api.js.map